import styled from "@emotion/styled";
export const Wrapper = styled.div``;

export const FeedThumbnail = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 10px;
`;
